

<div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
  <div class="btn-toolbar mb-2 mb-md-0">    <!-- *ngIf="canAccess(['edit_users'])"-->
  </div>
</div>

<!-- Buscador
<app-search (search)="handleSearch($event)"></app-search>-->

<!--<div class="form-group">
  <div class="input-group">
      <div class="input-group-text bg-white">
          <i class="fa fa-search"></i>
      </div>
      <input type="text" name="search" class="form-control" placeholder="Buscar" [(ngModel)]="search">
  </div>
</div>-->

<div class="row">
  <div class="col-6 input-group">
    <input type="text" id="search" class="form-control"  [placeholder]="'Ingrese el Nombre'"  [(ngModel)]="search" required>
    <input type="number" id="percentage" class="form-control"  [placeholder]="'Porcentaje'"  [(ngModel)]="percentage" required>
    <span class="input-group-btn">
      <button class="btn btn-primary rounded-0" (click)="refresh(1,search,percentage)"   [disabled]="!search || !percentage"   >Buscar</button>
    </span>
  </div>
</div>


<!--<div class="row no-gutters mt-4">
  <div class="col-12">

    <div class="row">
      <div class="col-12">
        <span>{{'label.search.category'}}</span>
      </div>
    </div>

    <div class="row">
      <div class="col-12 input-group">
        <input type="text" id="search" class="form-control" #search (keydown.enter)="updateWord(search.value)" [placeholder]="'label.3.characters'">
        <span class="input-group-btn">
          <button class="btn btn-primary rounded-0" (click)="updateWord(search.value)">{{'label.search'}}</button>
        </span>
      </div>
    </div>

  </div>
</div> -->

<div class="alert alert-primary" role="alert">
  <strong>ejemplo</strong>
</div>

<app-spinner></app-spinner>

<div class="table-responsive">
  <table class="table table-striped table-sm">
    <thead>
      <tr>
        <th>Departamento</th>
        <th>Localidad</th>
        <th>Municipio</th>
        <th>Nombre</th>
        <th>Años Activo</th>
        <th>Tipo Persona</th>
        <th>Tipo Persona</th>
        <th>Porcentaje</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let biblio of dictionarys">
        <td>{{biblio.departamento}}</td>
        <td>{{biblio.localidad}}</td>
        <td>{{biblio.municipio}}</td>
        <td>{{biblio.nombre}}</td>
        <td>{{biblio.anos_activo}}</td>
        <td>{{biblio.tipo_persona}}</td>
        <td>{{biblio.tipo_cargo}}</td>
        <td>{{biblio.porcentaje}}</td>
        <th></th>
        <td>
          <div class="btn-group mr-2" >
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<app-paginator
  [lastPage]="lastPage"
  (pageChanged)="refresh($event,search)"
></app-paginator>


